import React from 'react'
import RequestForm from "../../model/request-form"

type Props = {
    requestForm: RequestForm
}

export default class FormViewHeader extends React.Component<Props> {
    render() {
        const classes = Classes('form-header','gd-c-'+this.props.requestForm.settings.color)

        return (
            <div className={classes}>
                <div className="ui5-title-18 title">{this.props.requestForm.settings.headerTitle}</div>

                {this.props.requestForm.settings.headerDescription &&
                    <div className="ui5-txt-default-small description m-t-5">{this.props.requestForm.settings.headerDescription}</div>}
            </div>
        )
    }
}